/**
 * LoadingSpinner Component
 * 
 * CloudScape-based loading indicator for asynchronous operations.
 * Provides visual feedback to users during authentication,
 * form submissions, and data fetching.
 */

import { Box, Spinner } from '@cloudscape-design/components';
import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'normal' | 'big' | 'large' | 'small';
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'big', 
  message 
}) => {
  // Map 'small' to 'normal' for CloudScape Spinner
  const spinnerSize = size === 'small' ? 'normal' : size;
  
  return (
    <Box textAlign="center" padding="xxl">
      <Spinner size={spinnerSize} />
      {message && (
        <Box variant="p" color="text-body-secondary" margin={{ top: 's' }}>
          {message}
        </Box>
      )}
    </Box>
  );
};
